/**
 * 场景清单：每加一个新场景，只往这里挂一行。
 *
 * 场景本身在各目录里（suburb/、road/、city/、shops/），每个文件只管自己那块地图，
 * 谁把谁连起来、怎么跳，都是 world.js 从 portal 器物里读出来的。
 */
import { carportDoc } from './suburb/carport.js';
import { countryRoadDoc } from './suburb/country_road.js';
import { neighborYardDoc } from './suburb/neighbor_yard.js';
import { riversideDoc } from './suburb/riverside.js';

import { highwayDoc } from './road/highway.js';

import { gateDoc } from './city/gate.js';
import { mainStreetDoc } from './city/main_street.js';
import { marketDoc } from './city/market.js';
import { riverfrontDoc } from './city/riverfront.js';
import { yamenSqDoc } from './city/yamen_sq.js';
import { funStreetDoc } from './city/fun_street.js';

import { garageDoc } from './shops/garage.js';
import { eateryDoc } from './shops/eatery.js';
import { pawnDoc } from './shops/pawn.js';
import { generalDoc } from './shops/general.js';
import { innDoc } from './shops/inn.js';
import { pharmacyDoc } from './shops/pharmacy.js';
import { libraryDoc } from './shops/library.js';
import { yamenHallDoc } from './shops/yamen_hall.js';
import { petShopDoc } from './shops/pet_shop.js';
import { depotDoc } from './shops/depot.js';
import { junkyardDoc } from './shops/junkyard.js';
import { funRoomDoc } from './shops/fun_room.js';
import { onsenDoc } from './shops/onsen.js';

/** 全部静态场景文档（顺序无关，world.js 会重建索引） */
export const SCENE_DOCS = [
  // 城郊：家门外那一圈
  carportDoc, countryRoadDoc, neighborYardDoc, riversideDoc,
  // 城外：进城那段路
  highwayDoc,
  // 城门口 + 五个街区
  gateDoc, mainStreetDoc, marketDoc, riverfrontDoc, yamenSqDoc, funStreetDoc,
  // 十三处买卖
  garageDoc, eateryDoc, pawnDoc, generalDoc, innDoc, pharmacyDoc,
  libraryDoc, yamenHallDoc, petShopDoc, depotDoc, junkyardDoc, funRoomDoc, onsenDoc,
];

/** 顺手把单个文档也导出，方便分场景单独引用 */
export {
  carportDoc, countryRoadDoc, neighborYardDoc, riversideDoc,
  highwayDoc,
  gateDoc, mainStreetDoc, marketDoc, riverfrontDoc, yamenSqDoc, funStreetDoc,
  garageDoc, eateryDoc, pawnDoc, generalDoc, innDoc, pharmacyDoc,
  libraryDoc, yamenHallDoc, petShopDoc, depotDoc, junkyardDoc, funRoomDoc, onsenDoc,
};
